import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import { makeCategoryRoute } from '@utils/route';
import { replaceSpecialCharacters } from '@utils/utils';

import { Link } from '@components/common/Link/Link';
import { Picture } from '@components/common/Picture/Picture';
import { PlaceholderIcon } from '@components/icons/PlaceholderIcon';

import styles from './CategoryCard.module.scss';

type CategoryCardProps = {
    image: Global.ImageSet | null;
    title: string;
    id: number;
    slug: string;
};

export const CategoryCard: FunctionComponent<CategoryCardProps> = (props) => {
    const { image, title, slug } = props;

    return (
        <article className={styles.root} data-testid="category-card">
            <Link route={makeCategoryRoute(slug)} className={styles.link}>
                {image ? (
                    <Picture sources={image} alt={title} className={styles.image} />
                ) : (
                    <div className={clsx(styles.placeholder, styles.image)}>
                        <PlaceholderIcon />
                    </div>
                )}
                <h3
                    className={styles.title}
                    dangerouslySetInnerHTML={{ __html: replaceSpecialCharacters(title, '<br>') }}
                />
            </Link>
        </article>
    );
};
